import React from 'react';
import PropTypes from 'prop-types';

import styles from './SubscriptionContent.module.scss';

const SubscriptionContent = props => {
  const { children } = props;

  return <div className={styles.bns3_subscriptionContent}>{children}</div>;
};

SubscriptionContent.propTypes = {
  children: PropTypes.node,
};

export default SubscriptionContent;
